import { InjectionToken } from '@angular/core';
import { ActionReducerMap, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '@cemex/cmx-client-layout';

import * as fromShipmentLocationWorksheets from './shipment-location-worksheets.reducer';
import * as fromScheduleDates from './schedule-dates.reducer';
import * as fromOrdersForms from './orders-forms.reducer';
import * as fromOrdersCatalogs from './orders-catalogs.reducer';
import * as fromValuesAdded from './values-added.reducer';
import * as fromScheduleOrders from './schedule-orders-confirmation.reducer';
import * as fromPurchaseOrder from './purchase-order.reducer';
import { DCOFeatureState, DCOreducers } from '../../modules/dco/redux/reducers';
import * as fromSpecialScenarios from '../../modules/dco/redux/reducers/special-scenarios.reducer';
import * as fromPrices from './prices.reducer';

export interface MultipleOrderOnlineFeatureState {
  shipmentLocationWorksheets: fromShipmentLocationWorksheets.State;
  scheduleDates: fromScheduleDates.State;
  ordersForms: fromOrdersForms.State;
  ordersCatalogs: fromOrdersCatalogs.State;
  valuesAdded: fromValuesAdded.ValuesAddedState;
  orderConfirmation: fromScheduleOrders.ScheduleOrderConfirmationState;
  purchaseOrder: fromPurchaseOrder.MOOPurchaseOrderState;
  specialScenarios: fromSpecialScenarios.State;
  prices: fromPrices.State;
}

export const reducers = {
  shipmentLocationWorksheets: fromShipmentLocationWorksheets.reducer,
  scheduleDates: fromScheduleDates.reducer,
  ordersForms: fromOrdersForms.reducer,
  ordersCatalogs: fromOrdersCatalogs.reducer,
  valuesAdded: fromValuesAdded.reducer,
  orderConfirmation: fromScheduleOrders.reducer,
  purchaseOrder: fromPurchaseOrder.reducer,
  specialScenarios: fromSpecialScenarios.reducer,
  prices: fromPrices.reducer,
};

export const multipleOrderOnlineKey = 'multipleOrderOnline';
export interface MultipleOrderOnlineState extends State {
  multipleOrderOnlineState: MultipleOrderOnlineFeatureState;
  dco: DCOFeatureState;
}

export const reducerToken = new InjectionToken<ActionReducerMap<MultipleOrderOnlineState>>('COMBINED_REDUCERS');

export const reducerProvider = {
  provide: reducerToken,
  useFactory: () =>
    combineReducers({
      ...reducers,
      ...DCOreducers,
    }),
};

export const getMultipleOrderOnlineState =
  createFeatureSelector<MultipleOrderOnlineFeatureState>(multipleOrderOnlineKey);

export const getDCOState = createFeatureSelector<DCOFeatureState>(multipleOrderOnlineKey);

export const getSpecialScenariosMooState = createSelector(
  getMultipleOrderOnlineState,
  (state) => state.specialScenarios,
);

export const getSpecialScenariosMooEntities = createSelector(
  getSpecialScenariosMooState,
  fromSpecialScenarios.selectAllEntities,
);
